import React from 'react';
import PropTypes from 'prop-types';
import './data-cell.scss';
import clsx from 'clsx';
import { ColumnTypes } from '../../constants';
import RenText from '../../renderers/ren-text';
import RenFavourite from '../../renderers/ren-favourite';
import RenAvatarly from '../../renderers/ren-avatarly';
import RenNumber from '../../renderers/ren-number';
import RenDate from '../../renderers/ren-date';
import RenBadge from '../../renderers/ren-badge';
import RenBadges from '../../renderers/ren-badges';
import RenInputNumber from '../../renderers/ren-input-number';
import RenInputText from '../../renderers/ren-input-text';
import RenButton from '../../renderers/ren-button';
import RenList from '../../renderers/ren-list';
import RenDateWithDiff from '../../renderers/ren-date-with-diff';
import renOverflowingTextWrapper from '../../renderers/ren-overflowing-text-wrapper';

const Renderers = {
  [ColumnTypes.TEXT]: RenText,
  [ColumnTypes.FAVOURITE]: RenFavourite,
  [ColumnTypes.NUMBER]: RenNumber,
  [ColumnTypes.DATE]: RenDate,
  [ColumnTypes.CUSTOM]: RenText,
  [ColumnTypes.AVATAR]: RenAvatarly,
  [ColumnTypes.BADGE]: RenBadge,
  [ColumnTypes.BADGES]: RenBadges,
  [ColumnTypes.INPUT_NUMBER]: RenInputNumber,
  [ColumnTypes.INPUT_TEXT]: RenInputText,
  [ColumnTypes.BUTTON]: RenButton,
  [ColumnTypes.LIST]: RenList,
  [ColumnTypes.DATE_WITH_DIFF]: RenDateWithDiff,
  [ColumnTypes.OVERFLOWING_TEXT]: renOverflowingTextWrapper,
};

const DataCell = ({
  col, data, cellKey, onAction, loading, editable, inputErrors,
}) => {
  const {
    id, type, accessor, maxWidth,
  } = col;
  const cellType = editable ? ColumnTypes.INPUT_TEXT : type;
  const Renderer = Renderers[cellType];
  return (
    <td key={cellKey} className={clsx('tbl-td', id)} style={{ maxWidth }}>
      <Renderer
        id={id}
        accessor={accessor}
        data={data}
        onAction={onAction}
        columnData={col}
        loading={loading}
        isInvalid={editable && inputErrors[id]}
        suffixTooltip={editable ? inputErrors[id] : ''}
      />
    </td>
  );
};

DataCell.defaultProps = {
  data: {},
  onAction: () => { },
  loading: false,
  editable: false,
  inputErrors: {},
  cellKey: '',
};

DataCell.propTypes = {
  col: PropTypes.shape().isRequired,
  data: PropTypes.shape(),
  onAction: PropTypes.func,
  loading: PropTypes.bool,
  editable: PropTypes.bool,
  inputErrors: PropTypes.shape(),
  cellKey: PropTypes.string,
};

export default DataCell;
